import { TableHeadDataProps } from '../../components/Table/TableHead';

export const RtmTimeLogTableHeadData: TableHeadDataProps[] = [
  { id: 0, title: '' },
  { id: 1, title: 'Description' },
  { id: 2, title: 'Time Spent' },
  { id: 7, title: 'Actions' },
  { id: 8, title: '' },
];
